import React from "react";
import { motion } from "framer-motion";

const ASIAN_PAINTS_LOGO = "https://customer-assets.emergentagent.com/job_sri-paint-studio/artifacts/ev04kee6_asian-paints-logo-png_seeklogo-315813.png";
const BIRLA_OPUS_LOGO = "https://customer-assets.emergentagent.com/job_sri-paint-studio/artifacts/p931sulw_Birla%20Opus%20Paints_idNCvN4Z3T_1.svg";

export const PartnersSection = () => {
  return (
    <section id="partners" className="py-16 sm:py-20 lg:py-28 bg-white" data-testid="partners-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-10 sm:mb-14">
          <span className="text-purple-600 font-semibold tracking-wider uppercase text-xs sm:text-sm">Our Partners</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mt-2 sm:mt-3">
            Trusted <span className="text-purple-600">Brands</span>
          </h2>
          <p className="text-gray-600 mt-3 text-sm sm:text-base">Authorized dealer of India's leading paint manufacturers</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            className="bg-white rounded-2xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow text-center border border-gray-100" 
            data-testid="partner-asian-paints"
          >
            <div className="h-16 sm:h-20 flex items-center justify-center mb-4">
              <img src={ASIAN_PAINTS_LOGO} alt="Asian Paints" className="max-h-full max-w-[150px] sm:max-w-[180px] object-contain partner-logo" />
            </div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900">Asian Paints</h3>
            <p className="text-purple-600 font-medium mt-1 text-sm">Colour World Dealer</p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ delay: 0.1 }} 
            className="bg-white rounded-2xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow text-center border border-gray-100" 
            data-testid="partner-birla-opus"
          >
            <div className="h-16 sm:h-20 flex items-center justify-center mb-4">
              <img src={BIRLA_OPUS_LOGO} alt="Birla Opus" className="max-h-full max-w-[150px] sm:max-w-[180px] object-contain partner-logo" />
            </div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900">Birla Opus</h3>
            <p className="text-purple-600 font-medium mt-1 text-sm">Franchise Partner</p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ delay: 0.2 }} 
            className="bg-white rounded-2xl p-5 sm:p-6 lg:p-8 shadow-md hover:shadow-lg transition-shadow text-center border border-gray-100" 
            data-testid="partner-nexon-paints"
          >
            <div className="h-16 sm:h-20 flex items-center justify-center mb-4">
              <div className="text-2xl sm:text-3xl font-bold">
                <span className="text-blue-700">NEXON</span>
                <span className="text-green-500 ml-1">Paints</span>
              </div>
            </div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900">Nexon Paints</h3>
            <p className="text-purple-600 font-medium mt-1 text-sm">Authorized Dealer</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
